import { jsx } from "react/jsx-runtime";
import { useMemo, useContext, createContext } from "react";
import { useStudioSupportBranding } from "@brandclub/bc-widgets";
const FALLBACK_COPY = {
  teamLabel: "Support Team",
  pausedFooterCopy: "You're chatting with support team. Concierge is paused.",
  takeoverPlaceholder: "Message {firstName}…",
  deliveredCopy: "Delivered to Support Team",
  teamAvatarUrl: ""
};
const SupportCopyContext = createContext(FALLBACK_COPY);
const SupportThemeProvider = ({
  children,
  className
}) => {
  const branding = useStudioSupportBranding();
  const cssVars = useMemo(
    () => ({
      // `display: contents` makes this wrapper transparent for layout —
      // children participate in the parent's flex/grid context as if the
      // wrapper weren't there. CSS custom properties still cascade normally.
      display: "contents",
      // Cast to any so React's CSSProperties accepts custom -- properties.
      ["--bc-support-bg"]: branding.softBackgroundHex,
      ["--bc-support-border"]: branding.borderHex,
      ["--bc-support-dot"]: branding.accentDotHex,
      ["--bc-support-text"]: branding.textHex
    }),
    [branding.softBackgroundHex, branding.borderHex, branding.accentDotHex, branding.textHex]
  );
  const copy = useMemo(
    () => ({
      teamLabel: branding.teamLabel,
      pausedFooterCopy: branding.pausedFooterCopy,
      takeoverPlaceholder: branding.takeoverPlaceholder,
      deliveredCopy: branding.deliveredCopy,
      teamAvatarUrl: branding.teamAvatarUrl
    }),
    [
      branding.teamLabel,
      branding.pausedFooterCopy,
      branding.takeoverPlaceholder,
      branding.deliveredCopy,
      branding.teamAvatarUrl
    ]
  );
  return /* @__PURE__ */ jsx("div", { className, style: cssVars, children: /* @__PURE__ */ jsx(SupportCopyContext.Provider, { value: copy, children }) });
};
const useSupportCopy = () => useContext(SupportCopyContext);
export {
  SupportThemeProvider,
  useSupportCopy
};
//# sourceMappingURL=SupportThemeProvider.js.map
